// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';

import SVGCVATLogo from './assets/cvat-logo.svg';
import SVGAccountIcon from './assets/account-icon.svg';
import SVGEmptyTasksIcon from './assets/empty-tasks-icon.svg';
import SVGMenuIcon from './assets/menu-icon.svg';
import SVGCursorIcon from './assets/cursor-icon.svg';
import SVGMoveIcon from './assets/move-icon.svg';
import SVGRotateIcon from './assets/rotate-icon.svg';
import SVGFitIcon from './assets/fit-to-window-icon.svg';
import SVGZoomIcon from './assets/zoom-icon.svg';
import SVGRectangleIcon from './assets/rectangle-icon.svg';
import SVGPolygonIcon from './assets/polygon-icon.svg';
import SVGPointIcon from './assets/point-icon.svg';
import SVGPolylineIcon from './assets/polyline-icon.svg';
import SVGTagIcon from './assets/tag-icon.svg';
import SVGMergeIcon from './assets/merge-icon.svg';
import SVGGroupIcon from './assets/group-icon.svg';
import SVGSplitIcon from './assets/split-icon.svg';
import SVGMainMenuIcon from './assets/main-menu-icon.svg';
import SVGSaveIcon from './assets/save-icon.svg';
import SVGUndoIcon from './assets/undo-icon.svg';
import SVGRedoIcon from './assets/redo-icon.svg';
import SVGFirstIcon from './assets/first-icon.svg';
import SVGBackJumpIcon from './assets/back-jump-icon.svg';
import SVGPreviousIcon from './assets/previous-icon.svg';
import SVGPlayIcon from './assets/play-icon.svg';
import SVGPauseIcon from './assets/pause-icon.svg';
import SVGNextIcon from './assets/next-icon.svg';
import SVGForwardJumpIcon from './assets/forward-jump-icon.svg';
import SVGLastIcon from './assets/last-icon.svg';
import SVGInfoIcon from './assets/info-icon.svg';
import SVGFullscreenIcon from './assets/fullscreen-icon.svg';
import SVGObjectOutsideIcon from './assets/object-outside-icon.svg';
import SVGObjectInsideIcon from './assets/object-inside-icon.svg';
import SVGBackgroundIcon from './assets/background-icon.svg';
import SVGForegroundIcon from './assets/foreground-icon.svg';
import SVGCubeIcon from './assets/cube-icon.svg';
import SVGResetPerspectiveIcon from './assets/reset-perspective.svg';

export const CVATLogo = React.memo(
    (): JSX.Element => <SVGCVATLogo />,
);
export const AccountIcon = React.memo(
    (): JSX.Element => <SVGAccountIcon />,
);
export const EmptyTasksIcon = React.memo(
    (): JSX.Element => <SVGEmptyTasksIcon />,
);
export const MenuIcon = React.memo(
    (): JSX.Element => <SVGMenuIcon />,
);
export const CursorIcon = React.memo(
    (): JSX.Element => <SVGCursorIcon />,
);
export const MoveIcon = React.memo(
    (): JSX.Element => <SVGMoveIcon />,
);
export const RotateIcon = React.memo(
    (): JSX.Element => <SVGRotateIcon />,
);
export const FitIcon = React.memo(
    (): JSX.Element => <SVGFitIcon />,
);
export const ZoomIcon = React.memo(
    (): JSX.Element => <SVGZoomIcon />,
);
export const RectangleIcon = React.memo(
    (): JSX.Element => <SVGRectangleIcon />,
);
export const PolygonIcon = React.memo(
    (): JSX.Element => <SVGPolygonIcon />,
);
export const PointIcon = React.memo(
    (): JSX.Element => <SVGPointIcon />,
);
export const PolylineIcon = React.memo(
    (): JSX.Element => <SVGPolylineIcon />,
);
export const TagIcon = React.memo(
    (): JSX.Element => <SVGTagIcon />,
);
export const MergeIcon = React.memo(
    (): JSX.Element => <SVGMergeIcon />,
);
export const GroupIcon = React.memo(
    (): JSX.Element => <SVGGroupIcon />,
);
export const SplitIcon = React.memo(
    (): JSX.Element => <SVGSplitIcon />,
);
export const MainMenuIcon = React.memo(
    (): JSX.Element => <SVGMainMenuIcon />,
);
export const SaveIcon = React.memo(
    (): JSX.Element => <SVGSaveIcon />,
);
export const UndoIcon = React.memo(
    (): JSX.Element => <SVGUndoIcon />,
);
export const RedoIcon = React.memo(
    (): JSX.Element => <SVGRedoIcon />,
);
export const FirstIcon = React.memo(
    (): JSX.Element => <SVGFirstIcon />,
);
export const BackJumpIcon = React.memo(
    (): JSX.Element => <SVGBackJumpIcon />,
);
export const PreviousIcon = React.memo(
    (): JSX.Element => <SVGPreviousIcon />,
);
export const PauseIcon = React.memo(
    (): JSX.Element => <SVGPauseIcon />,
);
export const PlayIcon = React.memo(
    (): JSX.Element => <SVGPlayIcon />,
);
export const NextIcon = React.memo(
    (): JSX.Element => <SVGNextIcon />,
);
export const ForwardJumpIcon = React.memo(
    (): JSX.Element => <SVGForwardJumpIcon />,
);
export const LastIcon = React.memo(
    (): JSX.Element => <SVGLastIcon />,
);
export const InfoIcon = React.memo(
    (): JSX.Element => <SVGInfoIcon />,
);
export const FullscreenIcon = React.memo(
    (): JSX.Element => <SVGFullscreenIcon />,
);
export const ObjectOutsideIcon = React.memo(
    (): JSX.Element => <SVGObjectOutsideIcon />,
);
export const ObjectInsideIcon = React.memo(
    (): JSX.Element => <SVGObjectInsideIcon />,
);
export const BackgroundIcon = React.memo(
    (): JSX.Element => <SVGBackgroundIcon />,
);
export const ForegroundIcon = React.memo(
    (): JSX.Element => <SVGForegroundIcon />,
);
export const CubeIcon = React.memo(
    (): JSX.Element => <SVGCubeIcon />,
);
export const ResetPerspectiveIcon = React.memo(
    (): JSX.Element => <SVGResetPerspectiveIcon />,
);
